var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("Loading")
        : _c(
            "div",
            { staticClass: "matching" },
            [
              _vm._l(_vm.defaultMatchingItems, function(item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "matching--category" },
                  [
                    _c(
                      "b-row",
                      { attrs: { "align-v": "center" } },
                      [
                        _c("b-col", { attrs: { md: "3" } }, [
                          _c("h3", [_vm._v(_vm._s(item.label))])
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { md: "9" } }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "matching--category-items matching--category-items-no-item-x-padding"
                            },
                            [
                              _c("Item", {
                                staticClass: "force--bg-color-transparent",
                                attrs: {
                                  score: item.score,
                                  "max-score": item.maxScore,
                                  "with-percentage": false,
                                  "info-text": item.infoText
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "job-vita mt-4" },
                _vm._l(
                  _vm.vita.grids.filter(function(g) {
                    return g.hasData
                  }),
                  function(grid) {
                    return _c("Grid", {
                      key: grid.id,
                      attrs: { grid: grid, "job-profile-id": _vm.jobProfileId }
                    })
                  }
                ),
                1
              )
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }